import React, { useState } from 'react';
import * as Switch from "@radix-ui/react-switch";
import { CurrencyInput } from "components/Input/Inputs";
import { IField } from "components/Input/Inputs";
import { IFormInputMap } from '../hooks/useDealForm';

interface SettlementRateInputProps {
  field: IField<IFormInputMap>['field'];
}

const SettlementRateInput: React.FC<SettlementRateInputProps> = ({ field }) => {
  const [enabled, setEnabled] = useState(false);

  return (
    <div className="flex relative flex-col z-50">
      <div className="flex absolute left-48 -top-8 items-center">
        <Switch.Root
          className="w-[45px] h-[25px] bg-blue_gray-lite-bg rounded-full border-2 border-blue-700 outline-none cursor-default"
          id="airplane-mode"
          style={{ WebkitTapHighlightColor: "rgba(0, 0, 0, 0)" }}
          checked={enabled}
          onCheckedChange={(checked) => {
            setEnabled(checked);
            if (!checked) field.onChange("");
          }}
        >
          <Switch.Thumb
            className={`flex p-1 w-[20px] h-[20px] bg-blue-700_01 rounded-full shadow-black-900 transition-transform duration-100 ${
              enabled && "translate-x-5"
            } will-change-transform`}
          />
        </Switch.Root>
      </div>
      {enabled && (
        <CurrencyInput currencyType="INR" field={field} isLoading={!enabled} />
      )}
    </div>
  );
};

export default SettlementRateInput;